<template>
    <div class="bd">

        <div class="my-custom-table">
            <a-page-header title="通知列表" />
            <div class="search-bar">
                <div class="tabInput">
                    <a>通知标题：</a>
                    <a-input v-model:value="title" placeholder="请输入通知标题进行搜索" class="search-input" />
                </div>
                <div class="tab-button">
                    <div>
                        <a-button class="search-tow" type="primary" @click="onSearch"
                            :icon="h(SearchOutlined)">搜索</a-button>
                        <a-button class="search-tow" @click="onReset" :icon="h(RedoOutlined)">重置</a-button>
                    </div>
                    <div class="right-option">
                        <a-button type="primary" @click="toAdd" :icon="h(PlusCircleOutlined)">发布通知</a-button>
                        <!-- 添加数据 -->
                        <addComponent ref="childOpen" />
                    </div>
                </div>
            </div>
            <a-table :columns="columns" :data-source="data" :pagination="pagination" row-key="id">
                <template #bodyCell="{ column, text, record }">
                    <!-- 渲染颜色 -->
                    <template v-if="column.key === 'title'">
                        <a>
                            {{ record.title }}
                        </a>
                    </template>
                    <template v-if="column.key === 'type'">
                        <span>
                            <a-tag color="green">
                                {{ record.type }}
                            </a-tag>
                        </span>
                    </template>
                    <template v-if="column.key === 'priority'">
                        <span>
                            <a-tag color="red">
                                {{ record.priority }}
                            </a-tag>
                        </span>
                    </template>
                    <!-- 渲染修改项 -->
                    <template v-if="['title', 'green'].includes(column.dataIndex)">
                        <div>
                            <span v-if="column.key != 'title' && column.key != 'green'">
                                {{ text }}
                            </span>
                        </div>
                    </template>

                    <!-- 渲染操作按钮 -->
                    <template v-if="column.dataIndex === 'operation'">
                        <div class="editable-row-operations">
                            <a-popconfirm title="确认删除？" ok-text="是" cancel-text="否" @confirm="remove(record.id)">
                                <a style="margin: 10px;">删除</a>
                            </a-popconfirm>
                        </div>
                    </template>
                </template>
            </a-table>
        </div>
    </div>
</template>


<script>
import { announcePage, removeAnnounce } from '@/api/service'
import { SearchOutlined, RedoOutlined, PlusCircleOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { cloneDeep } from 'lodash-es';
import { ref, h } from 'vue';
import addComponent from './modal/addComponent.vue'; // 导入组件
export default {
    name: 'AnnouncePage',
    components: { addComponent },
    setup() {
        const data = ref([]); // 初始化为空数组
        const childOpen = ref(null);//子页面实例
        const title = ref('');//查询条件
        const pagination = ref({
            current: 1, // 当前页数
            pageSize: 10, // 每页显示条数
            total: 0, // 数据总数
            showSizeChanger: true, // 是否显示修改每页条数
            showQuickJumper: true, // 是否显示快速跳转
            onChange: (page, pageSize) => {
                pagination.value.current = page;
                pagination.value.pageSize = pageSize;
                list(); // 当分页改变时，重新获取数据
            },
            position: ['bottomLeft']//显示位置
        });
        //列表
        const columns = [
            { title: '标题', dataIndex: 'title', key: 'title', width: '20%', },
            { title: '类型', dataIndex: 'type', key: 'type', width: '10%', },
            { title: '发布人', dataIndex: 'publisherName', key: 'publisherName', width: '10%', },
            { title: '优先级', dataIndex: 'priority', key: 'priority', width: '10%', },
            { title: '发布时间', dataIndex: 'createdAt', key: 'createdAt', width: '10%', },
            { title: '操作', dataIndex: 'operation', width: '10%', },
        ];
        //查询数据
        const list = async () => {
            const response = await announcePage({
                pageNumber: pagination.value.current,
                pageSize: pagination.value.pageSize,
                title: title.value
            });
            if (response.code === 200) {
                pagination.value.total = response.totalRow || response.data.totalRow || response.data.total || 0; // 更新 total
                data.value = response.data.records.map(item => ({
                    id: item.id,
                    title: item.title,
                    type: item.type,
                    publisherName: item.publisherName,
                    createdAt: item.createdAt,
                    priority: item.priority,
                }));
            }
        };
        // 组件初始化时调用一次
        list();
        //搜索
        const onSearch = () => {
            pagination.value.current = 1; // 搜索时重置当前页数
            list();
        }
        //重置
        const onReset = () => {
            title.value = ''; // 重置搜索关键词
            list(); // 重置后重新获取数据
        }
        //添加
        const toAdd = () => {
            childOpen.value.open = true;
        }
        //删除菜单
        const deleteAnnounce = async (data) => {
            const response = await removeAnnounce(data);
            if (response.code === 200) {
                message.success('删除成功');
                return true;
            } else {
                message.error('删除失败' + response.msg);
                return false;
            }
        };
        //删除通知公告
        const remove = id => {
            if (deleteAnnounce(id)) {
                data.value = cloneDeep(data.value.filter(item => id != item.id));
            }
        };

        return {
            SearchOutlined,
            RedoOutlined,
            PlusCircleOutlined,
            announcePage,
            childOpen,
            addComponent,
            title,
            columns,
            data,
            remove,
            list,
            h,
            toAdd,
            onSearch,
            onReset,
            pagination,
        }
    }
}
</script>